import "./index.css";
import React from "react";
import { Button } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";

interface TypeInputHintProps {
  top: number;
  left?: number;
  width?: string | number;
  /**
   * @param show 是否展示
   */
  show?: boolean;
  /**
   * @param type 两种风格样式
   */
  type: "error" | "warn";
  /**
   * @param text 提醒文案
   * @default "You are out of free queries"
   */
  text: string;
  /**
   * @param ButtonText 按钮文字
   */
  buttonText: string;
  /**
   * @name onClick 点击按钮回调
   */
  onClick?(): void;
}

/**
 * @name InputHint Input输入框Message提示
 */
const InputHint: React.FC<TypeInputHintProps> = ({
  top,
  left,
  show,
  width,
  onClick,
  buttonText,
  type = "warn",
  text = "You are out of free queries for today.",
}) =>
  typeof show === "boolean" && show ? (
    <div
      style={{ top, left, width }}
      className={`input-hint ${
        type === "warn" ? "input-hint-warn" : "input-hint-error"
      }`}
    >
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="currentColor"
        >
          <rect width="18" height="18" rx="9" fill="currentColor" />
          <rect x="8" y="4" width="2" height="7" rx="1" fill="white" />
          <rect
            x="10"
            y="12"
            width="2"
            height="2"
            rx="1"
            transform="rotate(90 10 12)"
            fill="white"
          />
        </svg>
        <span>{text}</span>
      </div>

      {buttonText ? (
        <Button type="link" size="small" onClick={onClick}>
          {buttonText}
        </Button>
      ) : null}
    </div>
  ) : null;

export default InputHint;
